import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Grid, Card, CardContent, CardActionArea } from '@mui/material';
import { People, Pets, AdminPanelSettings } from '@mui/icons-material';

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();

  const adminCards = [
    {
      title: 'Manage Users',
      description: 'View, edit, and delete user accounts',
      icon: <People sx={{ fontSize: 48 }} />,
      path: '/admin/users',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    },
    {
      title: 'Manage Cats',
      description: 'View, edit, and delete cat listings',
      icon: <Pets sx={{ fontSize: 48 }} />,
      path: '/admin/cats',
      color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    },
  ];

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px)',
        py: 4,
        background: 'linear-gradient(180deg, #0f0f1a 0%, #1a1a2e 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
          <AdminPanelSettings sx={{ fontSize: 40, color: 'warning.main' }} />
          <Box>
            <Typography variant="h3" fontWeight="bold">
              Admin Dashboard
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Manage users and cats
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={4}>
          {adminCards.map((card) => (
            <Grid size={{ xs: 12, sm: 6 }} key={card.path}>
              <Card
                sx={{
                  height: '100%',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 16px 40px rgba(0,0,0,0.4)',
                  },
                }}
              >
                <CardActionArea onClick={() => navigate(card.path)} sx={{ height: '100%' }}>
                  <CardContent sx={{ p: 4 }}>
                    <Box
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: 3,
                        background: card.color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 3,
                        color: 'white',
                      }}
                    >
                      {card.icon}
                    </Box>
                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                      {card.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {card.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AdminDashboard;
